/** Build calendar cells for a month (1-based). Sunday-first weeks. */
export function buildMonthCells(year, month) {
  const first = new Date(Date.UTC(year, month - 1, 1));
  const daysInMonth = new Date(Date.UTC(year, month, 0)).getUTCDate();
  const leading = first.getUTCDay(); // 0=Sun

  const cells = [];
  for (let i = 0; i < leading; i += 1) cells.push({ date: null });
  for (let d = 1; d <= daysInMonth; d += 1) {
    const mm = String(month).padStart(2, '0');
    const dd = String(d).padStart(2, '0');
    cells.push({ date: `${year}-${mm}-${dd}` });
  }
  while (cells.length % 7 !== 0) cells.push({ date: null });
  return cells;
}

/**
 * Whether a grid cell should open the day drawer.
 *
 * A day with no sessions must still open: the drawer holds the only
 * Add-session panel, and an empty day is exactly the one an admin wants to
 * schedule a class on. Only the blank padding cells outside the month, which
 * carry no date, are inert.
 */
export function isDayCellClickable(cell) {
  return Boolean(cell && cell.date);
}
